'use strict';

var jsxRuntime = require('react/jsx-runtime');

const MediumAi = ({ testId, className })=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: [
            jsxRuntime.jsx("path", {
                d: "M12.7898 6.18705H14.907V14H12.7898V6.18705ZM13.8484 5.15827C13.6386 5.15827 13.4455 5.11031 13.2691 5.01439C13.0926 4.91847 12.952 4.78657 12.8471 4.61871C12.7422 4.45084 12.6897 4.27098 12.6897 4.07914C12.6897 3.88249 12.7422 3.70264 12.8471 3.53957C12.952 3.3717 13.0926 3.23981 13.2691 3.14388C13.4455 3.04796 13.6386 3 13.8484 3C14.0582 3 14.2514 3.04796 14.4278 3.14388C14.6042 3.23981 14.7425 3.3717 14.8427 3.53957C14.9476 3.70264 15 3.88249 15 4.07914C15 4.27098 14.9476 4.45084 14.8427 4.61871C14.7425 4.78657 14.6042 4.91847 14.4278 5.01439C14.2514 5.11031 14.0582 5.15827 13.8484 5.15827Z",
                fill: "currentColor"
            }),
            jsxRuntime.jsx("path", {
                d: "M1 14L4.57635 3.5827H7.3373L10.9208 14H8.61048L5.99974 5.93522H5.91391L3.29602 14H1ZM8.71062 9.90644V11.5971H3.18158V9.90644H8.71062Z",
                fill: "currentColor"
            })
        ]
    });
};

module.exports = MediumAi;
